import React from 'react';
import { PlusCircle, Coins } from 'lucide-react';

const ContributionsSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  frequencyOptions 
}) => {
  if (!formData.additionalContributions) return null;

  return (
    <div className="mb-6 bg-green-50 dark:bg-green-900/20 p-4 rounded-lg border border-green-200 dark:border-green-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <PlusCircle className="w-5 h-5 mr-2 text-green-500" />
        Пополнение вклада
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Сумма пополнения */}
        <div>
          <label htmlFor="contributionAmount" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Сумма пополнения
          </label>
          <div className="relative">
            <input
              type="text"
              id="contributionAmount"
              name="contributionAmount"
              value={formData.contributionAmount}
              onChange={handleInputChange}
              className={`form-input w-full pr-10 ${errors.contributionAmount ? 'input-error' : ''}`}
              placeholder="Введите сумму"
            />
            <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 dark:text-gray-400">
              <Coins className="w-4 h-4" />
            </span>
          </div>
          {errors.contributionAmount && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.contributionAmount}
            </p>
          )}
        </div>

        {/* Периодичность пополнения */}
        <div>
          <label htmlFor="contributionFrequency" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Периодичность
          </label>
          <select
            id="contributionFrequency"
            name="contributionFrequency"
            value={formData.contributionFrequency}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.contributionFrequency ? 'input-error' : ''}`}
          >
            {frequencyOptions.map((frequency) => (
              <option key={frequency.id} value={frequency.id}>
                {frequency.name}
              </option>
            ))}
          </select>
          {errors.contributionFrequency && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.contributionFrequency}
            </p>
          )}
        </div>

        {/* Месяц начала пополнений */}
        <div>
          <label htmlFor="contributionStartMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Начать с месяца
          </label>
          <input
            type="text"
            id="contributionStartMonth"
            name="contributionStartMonth"
            value={formData.contributionStartMonth}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.contributionStartMonth ? 'input-error' : ''}`}
            placeholder="Номер месяца"
          />
          {errors.contributionStartMonth && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.contributionStartMonth}
            </p>
          )}
        </div>
      </div>

      <div className="mt-4 bg-green-100 dark:bg-green-900/30 p-3 rounded-lg border border-green-200 dark:border-green-800">
        <div className="flex items-start">
          <PlusCircle className="w-5 h-5 text-green-600 dark:text-green-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-green-700 dark:text-green-300 mb-1">
              Важно о пополнениях
            </h4>
            <p className="text-xs text-green-600 dark:text-green-400">
              Регулярные пополнения вклада значительно увеличивают итоговую доходность. 
              При ежемесячных пополнениях даже на небольшую сумму ваш капитал растет быстрее за счет сложного процента.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContributionsSection;